"use client";

import { useEffect, useRef } from "react";
import { X } from "lucide-react";

const Modal = ({ title, children, onClose, size = "medium" }) => {
  const modalRef = useRef(null);

  // Close modal when Escape key is pressed
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Prevent scrolling on the body when modal is open
    document.body.style.overflow = "hidden";

    // Focus the modal when it opens for accessibility
    if (modalRef.current) {
      modalRef.current.focus();
    }

    return () => {
      window.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);

  // Determine modal width based on size prop
  let modalWidth = "32rem"; // medium (default)
  if (size === "small") modalWidth = "24rem";
  if (size === "large") modalWidth = "48rem";
  if (size === "full") modalWidth = "90%";

  return (
    <div
      className="fixed inset-0 bg-gray-800 bg-opacity-50 z-50 flex justify-center items-center p-4 transition-opacity duration-300 ease-in-out"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      ref={modalRef}
      tabIndex={-1}
    >
      <div
        className="bg-white rounded-lg shadow-lg overflow-hidden max-h-[90vh] w-full flex flex-col"
        style={{ maxWidth: modalWidth }}
      >
        {/* Modal Header */}
        <div className="flex justify-between items-center p-4 bg-indigo-600 text-white rounded-t-lg">
          <h2 id="modal-title" className="text-lg font-semibold">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-300 transition-colors duration-200"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        {/* Modal Content */}
        <div className="p-6 overflow-y-auto flex-1">{children}</div>

        {/* Modal Footer (optional) */}
        {/* <div className="p-4 bg-gray-100 rounded-b-lg">
          <button onClick={onClose} className="text-gray-700 hover:text-gray-900">
            Close
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Modal;